import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import Step from '../../../../../../../features/components/Forms/StepForm/Step'
import StartEndDateRangeFields from '../../../../../../ReusableFormFields/StartEndDateRangeFields'

import { dv360RightUploadAdDataSelector } from '../../../../../../../modules/selectors/rights'
import { END_DATE, START_DATE } from '../../../../../../ReusableFormFields/StartEndDateRangeFields/fields'

const stepFields = [START_DATE, END_DATE]

const DateRangeStep = ({ formik, handleStepChange }) => {
  const { campaign } = useSelector(dv360RightUploadAdDataSelector)

  const minStartDate = useMemo(() => {
    return new Date(campaign.date_start)
  }, [campaign])

  const maxEndDate = useMemo(() => {
    return new Date(campaign.date_stop)
  }, [campaign])

  const handleContinue = useCallback(() => {
    handleStepChange(stepFields)
  }, [handleStepChange])

  return (
    <Step stepTitle="What should the start and end dates be?" handleContinue={handleContinue}>
      <StartEndDateRangeFields formik={formik} minDate={minStartDate} maxDate={maxEndDate} />
    </Step>
  )
}

DateRangeStep.propTypes = {
  formik: PropTypes.object.isRequired
}

export default DateRangeStep
